// ---- Anastasia & Co. layer (frontend) ---------------------------------------
// Layer-owned extension seam (docs/layer-contract.md in the kit). The studio's
// public site owns '/' and the marketing routes below; the kit workspace
// (items, jobs, agents, Dev Console) lives at /app and friends. /admin is the
// owner's book — mounted non-public so the kit login gates it.
import React from 'react';
import SiteHome from './site/SiteHome';
import Work, { CaseStudy } from './site/Work';
import Services from './site/Services';
import Pricing from './site/Pricing';
import Film from './site/Film';
import Approach from './site/Approach';
import Studio from './site/Studio';
import Contact from './site/Contact';
import AdminMeetings from './site/AdminMeetings';

export const extRoutes = [];
export const extNav = [{ to: '/admin', label: 'The book' }];

export const extSite = {
  prefixes: ['/work', '/services', '/pricing', '/film', '/approach', '/studio', '/contact', '/admin'],
  routes: [
    { path: '/', element: <SiteHome /> },
    { path: '/work', element: <Work /> },
    { path: '/work/:slug', element: <CaseStudy /> },
    { path: '/services', element: <Services /> },
    { path: '/pricing', element: <Pricing /> },
    { path: '/film', element: <Film /> },
    { path: '/approach', element: <Approach /> },
    { path: '/studio', element: <Studio /> },
    { path: '/contact', element: <Contact /> },
    { path: '/admin', element: <AdminMeetings />, public: false },
  ],
  // Studio concierge: the kit agent dock, chat + voice for visitors (the
  // backend gates voice on config voice.publicAccess and rate-limits by IP).
  publicVoice: true,
};
